import {Grid} from '@mui/material';
import AppCard from 'main/core/AppCard';
import PropTypes from 'prop-types';
import DyelotAlert from './DyelotAlert';

const DyeLotAlerts = ({dyelotData}) => {
  const highRisk = dyelotData.filter((item) => item.count > 3);
  const moderateRisk = dyelotData.filter(
    (item) => item.count === 2 || item.count === 3,
  );
  const safeItems = dyelotData.filter((item) => item.count === 1);

  return (
    <AppCard title='Dye Lots - Ready for EU' sxStyle={{height: '100%'}}>
      <Grid container spacing={10}>
        <DyelotAlert
          title='High Risk (3+ Lots)'
          color='tag.red'
          data={highRisk}
        />

        <DyelotAlert
          title='Moderate Risk (2-3 Lots)'
          color='tag.yellow'
          data={moderateRisk}
        />

        <DyelotAlert
          title='Safe (Single Lot)'
          color='tag.green'
          data={safeItems}
        />
      </Grid>
    </AppCard>
  );
};

export default DyeLotAlerts;

DyeLotAlerts.propTypes = {
  dyelotData: PropTypes.array,
};
